import { Component } from "react";
import Loader from "../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../../utils/withRouter";
import { connect } from "react-redux";
import { toastError, toastSuccess, exhibitionActionId, DelegateAccountTypeActionId } from "../../../../utils/constants";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "react-modal";
import moment from "moment";
import AdminDrawer from "../../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../../common_components/header_with_logo";
import Pagination from "../../../../utils/pagination";
import { fill_action } from '../../../../actions/fillCombo_action';
import { insertUpdate_ExhibitionFeild_action, getExhibitionFeild_action } from '../../../../actions/admin_module_action/delegate_master_action/delegate_ExhibitionFeild_action';

class Delegate_ExhibitionFeild extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            currentPage: 1,
            ExihibitionID: '',
            ExhibitionFeildList: [],
            DescriptionList: [],
            tempDescriptionList: [],
            NoteTypeList: [],
            exhibitionList: [],
            ExhibitionID: '',
            AccountTypeID: '',
            AccountTypeList: [],
        }
        this.updateItem = this.updateItem.bind(this)
        this.checkSelectAll = this.checkSelectAll.bind(this)

    }

    componentDidMount() {
        this.getFillList(exhibitionActionId, '', '', '', '')
        this.getFillList(DelegateAccountTypeActionId, '', '', '', '')
    }

    getFillList(value, userID, keyword, keyvalue) {
        // this.setState({ isLoading: true })
        this.props
            .fill_action(value, (userID == '' || userID == null) ? null : userID, keyword != '' ? keyword : null, keyvalue != '' ? keyvalue : null)
            .then((data) => {
                if (data.error != 1) {
                    if (value == exhibitionActionId) {
                        this.setState({
                            exhibitionList: data.data,
                        })
                    }
                    if (value == DelegateAccountTypeActionId) {
                        this.setState({
                            AccountTypeList: data.data,
                        })
                    }
                }
            })
            .catch((e) => {
                console.log(e);
            });

    }

    updateItem(item) {
        this.setState({ currentPage: item });
    }

    getExhibitionFeildDetails() {
        const { ExhibitionID, AccountTypeID } = this.state
        this.setState({ isLoading: true })
        this.props.getExhibitionFeild_action(ExhibitionID, AccountTypeID)
            .then((data) => {
                if (data.error != 1) {
                    if (data.data != '') {
                        if (data.detailsData != '') {
                            const result = data.data.map(item1 => {
                                const isPresentInArray2 = data.detailsData.some(item2 => item2.FieldID === item1.FieldID);
                                const IsMandatoryArray = data.detailsData.some(item2 => item2.FieldID === item1.FieldID && item2.IsMandatory);

                                return { ...item1, IsSelect: isPresentInArray2 ? 1 : 0, IsMandatory: IsMandatoryArray ? 1 : 0, };
                            });
                            this.setState({ ExhibitionFeildList: result })
                        } else {
                            data.data.map((item) => {
                                item.IsSelect = false
                            })
                            this.setState({ ExhibitionFeildList: data.data })
                        }
                    }
                    if (data.detailsData != '') {

                    }
                    this.setState({ isLoading: false })
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    insertUpdateExhibitionFeildDetails() {
        const { ExhibitionFeildList, ExhibitionID, AccountTypeID } = this.state
        this.setState({ isLoading: true })
        console.log("ExhibitionFeildList--->", ExhibitionFeildList)
        const array = []
        ExhibitionFeildList.map(item => {
            if (item.IsSelect == true) {
                array.push({
                    FieldId: item.FieldID,
                    isMandatory: item.IsMandatory,
                })
            }
        })
        this.props.insertUpdate_ExhibitionFeild_action(ExhibitionID, AccountTypeID, array)
            .then((data) => {
                if (data.error != 1) {
                    this.getExhibitionFeildDetails()
                    toastSuccess("data updated Successfuly!")
                    this.setState({ isLoading: false })
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    areAllParamsNotBlankExcept(arr, exceptKeys) {
        return arr.every(obj => {
            return Object.keys(obj).every(key => {
                console.log("obj[key]----->", obj[key])
                return !exceptKeys.includes(key) || (obj[key] !== null && obj[key] !== undefined && obj[key] !== '');
            });
        });
    }

    deleteExhibitionFeildDetails(id) {
        // this.setState({ isLoading: true })
        this.props.deleteExhibitionFeild_action(id)
            .then((data) => {
                if (data.error != 1) {
                    this.getExhibitionFeildDetails()
                    // this.setState({ isLoading: false })
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    addExhibitionFeildList(i) {
        const { ExhibitionFeildList } = this.state
        ExhibitionFeildList.splice(
            i + 1, 0, {
            id: ExhibitionFeildList.length + 1,
            B2BTimeSlotID: '',
            ExhibitionID: '',
            B2BDate: '',
            B2BStartTime: '',
            B2BEndTime: '',
            B2BLocation: ''
        }
        )
        this.setState({ ExhibitionFeildList: ExhibitionFeildList })
    }

    deleteExhibitionFeildList(id, B2BTimeSlotID) {
        if (B2BTimeSlotID != '') {
            this.deleteExhibitionFeildDetails(B2BTimeSlotID)
        } else {
            this.setState({ isLoading: true })
            const { ExhibitionFeildList } = this.state
            const filterArray = ExhibitionFeildList.filter(item => item.id != id)
            filterArray.map((item, i) => {
                item.id = i + 1
            })
            this.setState({ ExhibitionFeildList: filterArray }, () => {
                this.setState({ isLoading: false })
            })
        }
    }

    onExhibitionFeildInput(event, i, value) {
        const { ExhibitionFeildList } = this.state
        ExhibitionFeildList.map((data, index) => {
            if (i == index) {
                if (value == 'IsSelect') {
                    data.IsSelect = event
                    if (!event) {
                        data.IsMandatory = event
                    }
                } else {
                    data.IsMandatory = event
                    if (event) {
                        data.IsSelect = event
                    }
                }
            }
        })
        this.setState({ ExhibitionFeildList: ExhibitionFeildList })
    }

    onSelectAll(event, value) {
        const { ExhibitionFeildList } = this.state
        // if (event) {
        ExhibitionFeildList.map((data, index) => {
            if (value == 'IsSelect') {
                data.IsSelect = event
                if (!event) {
                    data.IsMandatory = event
                }
            } else {
                data.IsMandatory = event
                if (event) {
                    data.IsSelect = event
                }
            }
        })
        this.setState({ ExhibitionFeildList: ExhibitionFeildList })
        // }
    }

    checkSelectAll(value) {
        const { ExhibitionFeildList } = this.state
        var isAllSelect = true
        // if (event) {
        if (value == 'IsSelect') {

            for (var i = 0; i < ExhibitionFeildList.length; i++) {
                if (!ExhibitionFeildList[i].IsSelect) {
                    isAllSelect = false
                    break
                }
            }
        } else {
            for (var i = 0; i < ExhibitionFeildList.length; i++) {
                if (!ExhibitionFeildList[i].IsMandatory) {
                    isAllSelect = false
                    break
                }
            }
        }

        return isAllSelect
        // }
    }



    record(ExhibitionFeildList) {
        return (
            <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                <thead>
                    <tr style={{ border: '1px solid #ccc' }}>
                        <th style={{ width: '90%' }}>Field Name</th>
                        <th className="text-center" style={{ width: '10%' }}>Checked
                            {ExhibitionFeildList.length > 0 && ExhibitionFeildList != null && <input
                                type="checkbox" className="mt-1 ms-2"
                                checked={this.checkSelectAll('IsSelect')}
                                onChange={(e) => this.onSelectAll(e.target.checked, 'IsSelect')}
                            />}
                        </th>
                        <th className="text-center" style={{ width: '10%' }}>Mandatory
                            {ExhibitionFeildList.length > 0 && ExhibitionFeildList != null && <input
                                type="checkbox" className="mt-2 ms-2"
                                checked={this.checkSelectAll('IsMandatory')}
                                onChange={(e) => this.onSelectAll(e.target.checked, 'IsMandatory')}
                            />}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {/* {
                        ExhibitionFeildList.length > 0 && ExhibitionFeildList != null ? (
                            <tr key={Math.random()}>
                                <td><strong>ALL</strong></td>
                                <td className="text-center">
                                    <input
                                        type="checkbox"
                                        checked={this.checkSelectAll('IsSelect')}
                                        onChange={(e) => this.onSelectAll(e.target.checked, 'IsSelect')}
                                    />
                                </td>
                                <td className="text-center">
                                    <input
                                        type="checkbox"
                                        checked={this.checkSelectAll('IsMandatory')}
                                        onChange={(e) => this.onSelectAll(e.target.checked, 'IsMandatory')}
                                    />
                                </td>
                            </tr>
                        ) : <></>
                    } */}
                    {
                        ExhibitionFeildList != '' && ExhibitionFeildList != null ? (
                            ExhibitionFeildList.map((data, i) => (
                                <tr key={i}>
                                    <td>{data.FieldName}</td>
                                    <td className="text-center">
                                        <input
                                            type="checkbox"
                                            checked={data.IsSelect}
                                            onChange={(e) => this.onExhibitionFeildInput(e.target.checked, i, 'IsSelect')}
                                        />
                                    </td>
                                    <td className="text-center">
                                        <input
                                            type="checkbox"
                                            checked={data.IsMandatory}
                                            onChange={(e) => this.onExhibitionFeildInput(e.target.checked, i, 'IsMandatory')}
                                        />
                                    </td>
                                </tr>
                            ))
                        ) : (<tr><td colSpan={6} className='text-center'>Record not found</td></tr>)
                    }
                </tbody>
            </table>)
    }


    render() {
        const { isLoading, ExhibitionFeildList, currentPage, ExhibitionID, AccountTypeID, AccountTypeList } = this.state

        const recordsPerPage = 10
        const indexOfLastRecord = currentPage * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
        // Records to be displayed on the current page
        const currentRecords = ExhibitionFeildList.slice(indexOfFirstRecord, indexOfLastRecord)
        const nPages = Math.ceil(ExhibitionFeildList.length / recordsPerPage)

        return (
            <>

                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}

                <ToastContainer />
                <HeaderWithLogo />
                <>
                    <div className="app-content with-dr-container com-height" style={{ marginTop: '5rem' }}>
                        <AdminDrawer />
                        <div className="row" style={{ marginLeft: '0.3rem' }}>
                            <div className="step-name">
                                <p>Registration Field Access</p>
                            </div>
                        </div>
                        <div className="row" style={{ margin: 'auto' }}>
                            <div class="col-md-3 mt-2">
                                <label>Exhibition Name<span className="text-red">*</span></label>
                                <select className="form-control"
                                    value={ExhibitionID}
                                    onChange={(e) => this.setState({ ExhibitionID: e.target.value, ExhibitionFeildList: '' }, () => e.target.value != '' && AccountTypeID != '' && this.getExhibitionFeildDetails())}
                                >
                                    <option value={''}>Select</option>
                                    {
                                        this.state.exhibitionList.length > 0 && this.state.exhibitionList.map((data) => (
                                            <option key={data.ExhibitionID} value={data.ExhibitionID}>{data.ExhibitionName}</option>
                                        ))
                                    }
                                </select>
                            </div>
                            <div class="col-md-3 mt-2">
                                <label>Account Type<span className="text-red">*</span></label>
                                <select className="form-control"
                                    value={AccountTypeID}
                                    onChange={(e) => this.setState({ AccountTypeID: e.target.value, ExhibitionFeildList: '' }, () => e.target.value != '' && ExhibitionID != '' && this.getExhibitionFeildDetails())}
                                >
                                    <option value={''}>Select</option>
                                    {
                                        this.state.AccountTypeList.length > 0 && this.state.AccountTypeList.map((data) => (
                                            <option key={data.AccountTypeID} value={data.AccountTypeID}>{data.Name}</option>
                                        ))
                                    }
                                </select>
                            </div>
                        </div>
                        <div className="row mt-2 m-0">
                            <div className="asc">
                                <div className="table-responsive"
                                >
                                    {this.record(ExhibitionFeildList)}
                                </div>
                            </div>
                            {ExhibitionFeildList != '' && <div class="col-md-12 ">
                                <button type="button" class="btn btn-aqua rounded-2 mb-0 mt-2 mb-3" style={{ float: 'right' }}
                                    onClick={() => this.insertUpdateExhibitionFeildDetails()}>
                                    Save
                                </button>
                            </div>}
                        </div>
                    </div>

                </>

            </>
        );
    }
}

export default withRouter(connect(null, { fill_action, insertUpdate_ExhibitionFeild_action, getExhibitionFeild_action })(Delegate_ExhibitionFeild));